export default "__VITE_ASSET__DDYRX9H2__"